<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateCommission)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Commission - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="agency" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Agency</label>
                  <md-select v-model="agency" name="agency">
                    <md-option value="">Select Agency</md-option>
                    <md-option
                      v-for="c in agencies"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="university" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>University</label>
                  <md-select v-model="university" name="university">
                    <md-option value="">Select University</md-option>
                    <md-option
                      v-for="c in universities"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="commission"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>%</md-icon>
                  <label>Commission Rate</label>
                  <md-input v-model="commission" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="fix_sum_price"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Fix Price</label>
                  <md-input v-model="fix_sum_price" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="status" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>rule</md-icon>
                  <label>Status</label>
                  <md-select v-model="status" name="status">
                    <md-option value="">Select Status</md-option>
                    <md-option value="2">Active</md-option>
                    <md-option value="3">Inactive</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Commission
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      commissionID: null,

      agencies: [],
      universities: [],
      main_users: [],

      agency: null,
      university: null,
      commission: null,
      fix_sum_price: null,
      status: null
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateCommission() {
      let data = {
        agency: this.agency,
        university: this.university,
        commission: this.commission,
        fix_sum_price: this.fix_sum_price,
        status: this.status
      };
      var post_data = {};
      for (const field in data) {
        if (
          data[field] === null ||
          data[field] === undefined ||
          data[field] === ""
        ) {
          continue;
        }
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          post_data[field] = data[field];
        }
      }
      this.$store
        .updateCommission(post_data, this.commissionID)
        .then(response => {
          this.$notify({
            message: "Commission updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.commissionID = this.$route.params.id;
    this.$store
      .getAgencies({"limit": 500})
      .then(response => {
        this.agencies = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
    this.$store
      .getUniversities()
      .then(response => {
        this.universities = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style>
.picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
